import React from "react";
import "./SiteLogo.css";

const SiteLogo = () => {
  return (
    <div className="site-logo">
      SignalBleed<span>.NYC</span>
    </div>
  );
};

export default SiteLogo;
